import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=1c366e39&scoped=true&lang=pug"
import script from "./LogList.vue?vue&type=script&lang=js"
export * from "./LogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c366e39",
  null
  
)

export default component.exports